import React from 'react';
import { motion } from "framer-motion";
import { pageVariants } from "../animations/pageTransitions"; // Import animation config
import "./Legals.css";

const SellShareInfo = () => {
  return (
    <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
      <div className="legal-container">
        <h1>Do Not Sell or Share My Personal Information</h1>

        <p>
          Under the California Consumer Privacy Act (CCPA), California residents have the right to opt out of the sale or sharing of their personal data.
          At S&S Healthcare Consulting, we do not sell personal data to third parties.
        </p>

        <div className="legal-highlight">
          <p>✔ No data sales: We do not sell your personal information.</p>
          <p>✔ Privacy first: Your information is used only for operational purposes.</p>
          <p>✔ Data protection: We follow strict security measures to keep your data safe.</p>
        </div>

        <p style={{ textAlign: "center" }}>
          If you wish to exercise your data rights or restrict data sharing, please contact us at <strong>contact@sshealthcareconsulting.com</strong>.
        </p>

      </div>
    </motion.div>
  );
};

export default SellShareInfo;
